import { app } from "js/namespaces";
import { controls, Dialog } from "js/editor/ui";
import { $ } from "js/vendor";
import { ds } from "js/core/models/dataService";
import { HelpPanel } from "js/editor/helpView";
import { FeatureType } from "common/features";
import { UpgradePlanDialogType } from "js/react/views/MarketingDialogs/UpgradePlanDialog";
import { trackActivity } from "js/core/utilities/utilities";
import { SlideRevisionsDialog } from "js/editor/dialogs/revisionHistory";
import { DirectionType } from "common/constants";
import Api from "js/core/api";
import isConnected from "js/core/utilities/isConnected";
import { ShowDialog, ShowOfflineDialog, ShowUpgradeDialog, ShowWarningDialog } from "js/react/components/Dialogs/BaseDialog";
import { CreateNewPresentationDialog } from "js/editor/CreatePresentationDialog/CreateNewPresentationDialog";
import { PresentationLibraryController } from "../PresentationLibrary/PresentationLibraryController";
import { ShowMessageDialog } from "js/react/components/Dialogs/BaseDialog";
import UserOptionsContainer from "js/react/views/UserOptions/UserOptionsContainer";
import { getHelpMenu } from "../helpMenu";
import { ShortcutView } from "../shortcutView";
import FeedbackDialog from "../../react/components/Dialogs/FeedbackDialog";
import getUserProfile from "js/core/services/userProfiles";

export class UIController {
    static gotoMarketingPage() {
        window.location.href = "/?";
    }

    static getWorkspaceId() {
        return ds.selection && ds.selection.presentation
            ? ds.selection.presentation.getWorkspaceId()
            : app.appState.attributes.presentations.workspaceId;
    }

    static getOrganizationId() {
        if (UIController.getWorkspaceId() == "personal") {
            return null;
        } else {
            return UIController.getWorkspaceId();
        }
    }

    static isTeamWorkspace() {
        return UIController.getOrganizationId() !== null;
    }

    // return all team members in the current org
    static async getAllTeamMembers() {
        const defaultTeam = ds.teams.defaultTeamForOrg(app.appState.orgId);
        const allMemberIds = Object.keys(defaultTeam.get("members"));
        const userProfiles = await Promise.all(allMemberIds.map(memberId => getUserProfile(memberId)));
        const allUsers = userProfiles.map(user => ({ ...user, isChecked: false }));
        return allUsers;
    }

    static isSharedThemeRequiredForWorkspace() {
        const workspaceId = this.getWorkspaceId();
        if (workspaceId === "personal") {
            return false;
        }

        const defaultTeam = ds.teams.defaultTeamForOrg(workspaceId);
        return defaultTeam.get("isSharedThemeRequired");
    }

    static async showCreatePresentationDialog(libraryFilter) {
        //offline currently not supported as it just errors out when you try to create a presentation.
        //To be nice to our users, we'll check twice instead of showing the error after they select a theme.
        if (!isConnected.connected) {
            ShowOfflineDialog();
            return;
        }

        ShowDialog(CreateNewPresentationDialog, { libraryFilter, requireSharedTheme: this.isSharedThemeRequiredForWorkspace() });
    }

    static showUserOptionsDialog(defaultPane) {
        ShowDialog(UserOptionsContainer, {
            workspaceId: UIController.getWorkspaceId(),
            defaultPane
        });
    }

    static toggleHelpPanel(includeBuildInfo = false) {
        controls._createMenu($(".help-button"), getHelpMenu(includeBuildInfo));
    }

    static toggleShortcutPanel() {
        if ($(".shortcut_view").length == 0) {
            this.shortcutView = new ShortcutView();
            app.mainView.$el.append(this.shortcutView.render().$el);
            this.shortcutView.toggle(true);
        } else if (this.shortcutView && this.shortcutView.isShowingSideBar) {
            this.shortcutView.close();
            this.shortcutView = null;
        }
    }

    static hideHelpPanel() {
        if (this.helpPanel) {
            this.helpPanel.close();
            this.helpPanel = null;
        }
    }

    static showVersionHistory(options = {}) {
        const workspaceId = ds.selection.presentation.getWorkspaceId();
        if (!app.user.features.isFeatureEnabled(FeatureType.REVISION_HISTORY, workspaceId)) {
            ShowUpgradeDialog({
                type: UpgradePlanDialogType.UPGRADE_PLAN,
                analytics: { "cta": "Revision History", ...ds.selection.presentation.getAnalytics() },
                workspaceId
            });
            return;
        }
        //setting selection element to null so pending team slide change can be saved
        ds.selection.element = null;

        trackActivity("Editor", "ShowRevisionHistory");
        app.mainView.editorView.showSideBar(new SlideRevisionsDialog({
            isReadOnly: options.isReadOnly,
            presentation: ds.selection.presentation,
            slide: ds.selection.slide
        }), true, DirectionType.LEFT);
    }

    static showFeedbackDialog() {
        ShowDialog(FeedbackDialog);
    }
}
